import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'lp2-generic-tile-body',
  templateUrl: './generic-tile-body.component.html',
  styleUrls: ['./generic-tile-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericTileBodyComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() type: string;
  @Input() description: string;
}

@NgModule({
  declarations: [GenericTileBodyComponent],
  imports: [CommonModule],
  exports: [GenericTileBodyComponent],
})
export class GenericTileBodyModule {}



// WEBPACK FOOTER //
// ./ts/app/components/generic-tile-body/generic-tile-body.component.ts